import { isNative, getGlobalLightHub } from "../utils";
import { nextTick } from "./next-tick";

const lighthub = getGlobalLightHub();
const _Promise = lighthub && lighthub.origins._Promise;

let P;

if (_Promise && isNative(_Promise)) {
  P = _Promise;
} else {
  const Bluebird = require('bluebird');
  Bluebird.setScheduler(function(fn) {
    nextTick(fn);
  });
  P = Bluebird;
}

export default P;
